<template>
  <article class="" v-if="!getIsCompleteRegistration()">
    <p align="center">Selecciona una opción del menú izquierdo</p>
  </article>
</template>

<script>
  export default {
    data: () => ({
    })
  }
</script>



// WEBPACK FOOTER //
// src/components/views/Home.vue